export const getHoneypotConfig = () => ({
  DISABLE_HONEYPOTS: false,
  maxFieldsPerStep: 1
});